import React from "react";

export const useGenericContext = <T>(context: React.Context<T>) => {
    const ctx = React.useContext(context);
    if (!ctx) {
        throw Error(`use${context.displayName} must be used within a ${context.displayName}Provider`);
    }
    return ctx;
};
